// auth related images
import bigBRed from "../assets/images/big-b-red.svg";
import bigBBlue from "../assets/images/big-b-blue.svg";
import emailIcon from "../assets/icons/email-icon.png";
import facebookBlue from "../assets/icons/facebook_bue.svg";
import googleColored from "../assets/icons/google_colored.svg";

// icons and drawings
import Battles from "../assets/icons/battle.svg";
import refrrer from "../assets/icons/refrrer.svg";
import freeBox from "../assets/icons/free-box.png";
import masterCard from "../assets/icons/Master.svg";
import applePay from "../assets/icons/applePay.svg";
import visa from "../assets/icons/visa_inc_logo.svg";
import orangeB from "../assets/drawings/orangeB.svg";
import purpleB from "../assets/drawings/purpleB.svg";
import kycBadge from "../assets/drawings/KYCBadge.svg";
import bitCoin from "../assets/icons/bitCoinRounded.svg";
import tether from "../assets/icons/tetherCoinRounded.svg";
import ethereum from "../assets/icons/etherumCoinRouded.svg";
import uploadFilled from "../assets/icons/upload_filled.svg";
import boxesOutlinedLightPurple from "../assets/icons/boxes.svg";
import blackPencilIcon from "../assets/icons/black_pencil_icon.svg";

// ===== purple =====
import topupFilledPurple from "../assets/icons/profile/topup_filled_purple.svg";
import Boxes from "../assets/icons/boxes.svg";
import profileFilledPurple from "../assets/icons/refrrer.svg";
import cartBagFilledPurple from "../assets/icons/profile/cart_bag_filled_purple.svg";
import documentsFilledPurple from "../assets/icons/profile/documents_filled_purple.svg";
import withdrawalsFilledPurple from "../assets/icons/profile/withdraw_filled_purple.svg";
import transactionsFilledPurple from "../assets/icons/profile/transactions_filled_purple.svg";
import justiceScaleFilledPurple from "../assets/icons/profile/justice_scale_filled_purple.svg";

// ===== light filled =====
import topupFilledLight from "../assets/icons/profile/topup_filled_light.svg";
import boxesFilledLight from "../assets/icons/profile/boxes_filled_light.svg";
import profileFilledLight from "../assets/icons/profile/profile_filled_light.svg";
import cartBagFilledLight from "../assets/icons/profile/cart_bag_filled_light.svg";
import documentsFilledLight from "../assets/icons/profile/documents_filled_light.svg";
import withdrawalsFilledLight from "../assets/icons/profile/withdraw_filled_light.svg";
import transactionsFilledLight from "../assets/icons/profile/transactions_filled_light.svg";
import justiceScaleFilledLight from "../assets/icons/profile/justice_scale_filled_light.svg";

// ===== light outlined =====
import riskIndicatorLight from "../assets/icons/risk_indicator_light.svg";
import topupOutlinedLight from "../assets/icons/profile/topup_outlined_light.svg";
import boxesOutlinedLight from "../assets/icons/profile/boxes_outlined_light.svg";
import profileOutlinedLight from "../assets/icons/refrrer.svg";
import cartBagOutlinedLight from "../assets/icons/profile/cart_bag_outlined_light.svg";
import documentsOutlinedLight from "../assets/icons/profile/documents_outlined_light.svg";
import withdrawalsOutlinedLight from "../assets/icons/profile/withdraw_outlined_light.svg";
import transactionsOutlinedLight from "../assets/icons/profile/transactions_outlined_light.svg";
import justiceScaleOutlinedLight from "../assets/icons/profile/justice_scale_outlined_light.svg";

// ===== dark filled =====
import riskIndicatorDark from "../assets/icons/risk_indicator_dark.svg";
import boxesFilledDark from "../assets/icons/profile/boxes_filled_dark.svg";
import topupFilledDark from "../assets/icons/profile/topup_filled_dark.svg";
import profileFilledDark from "../assets/icons/profile/profile_filled_dark.svg";
import cartBagFilledDark from "../assets/icons/profile/cart_bag_filled_dark.svg";
import gameHistoryFilledDark from "../assets/icons/profile/game_history_dark.svg";
import documentsFilledDark from "../assets/icons/profile/documents_filled_dark.svg";
import withdrawalsFilledDark from "../assets/icons/profile/withdraw_filled_dark.svg";
import transactionsFilledDark from "../assets/icons/profile/transactions_filled_dark.svg";
import justiceScaleFilledDark from "../assets/icons/profile/justice_scale_filled_dark.svg";

// ===== dark outlined =====
import boxesOutlinedDark from "../assets/icons/profile/boxes_outlined_dark.svg";
import topupOutlinedDark from "../assets/icons/profile/topup_outlined_dark.svg";
import profileOutlinedDark from "../assets/icons/profile/profile_outlined_dark.svg";
import cartBagOutlinedDark from "../assets/icons/profile/cart_bag_outlined_dark.svg";
import documentsOutlinedDark from "../assets/icons/profile/documents_outlined_dark.svg";
import withdrawalsOutlinedDark from "../assets/icons/profile/withdraw_outlined_dark.svg";
import transactionsOutlinedDark from "../assets/icons/profile/transactions_outlined_dark.svg";
import justiceScaleOutlinedDark from "../assets/icons/profile/justice_scale_outlined_dark.svg";
import trashCanOutlinedDark from "../assets/icons/trash_can_outlined_dark.svg";
import trashCanOutlinedLight from "../assets/icons/trash_can_outlined_light.svg";
import trashCanFilledDark from "../assets/icons/trash_can_filled_dark.svg";
import trashCanFilledLight from "../assets/icons/trash_can_filled_light.svg";
import trashCanOutlinedPurple from "../assets/icons/trash_can_outlined_purple.svg";

// home page images
import boxesGif from "../assets/images/boxes.gif";

// modal images
import fireworkScatterd from "../assets/drawings/fireworkScatterd.png";

import backdropLoader from "../assets/gifs/logo_loader.gif";

// card images
import deposit from "../assets/drawings/Withdraw.png";
import registerTopup from "../assets/images/SignUp.png";
import productsBattle from "../assets/drawings/products-battle.png";

// profile related images
import logout from "../assets/icons/logout.svg";
import bgBoxes from "../assets/images/bg-boxes.png";
import doubleBOutlined from "../assets/icons/double-b-outlined.svg";
import lightSelectedBattle from "../assets/icons/battlesIconFilledPurple.svg";
const userAvatarReplacement =
  "https://s.gravatar.com/avatar/9c8383f43b954ffc52366dea5b4b9205?d=retro&r=r&s=100";

export const authImages = {
  googleColored,
  facebookBlue,
  emailIcon,
  bigBBlue,
  bigBRed,
};

export const profileImages = {
  logout,
  bgBoxes,
  doubleBOutlined,
  userAvatarReplacement,
};

export const home = {
  boxesGif,
};
export const gifs = {
  backdropLoader,
};
export const modalImages = { fireworkScatterd };

export const icons = {
  visa,
  tether,
  freeBox,
  bitCoin,
  orangeB,
  purpleB,
  Boxes,
  refrrer,
  applePay,
  ethereum,
  Battles,
  kycBadge,
  masterCard,
  uploadFilled,
  blackPencilIcon,
  riskIndicatorDark,
  riskIndicatorLight,
  lightSelectedBattle,
  boxesOutlinedLightPurple,
};

export const profilePurpleIcons = {
  topupFilledPurple,
  profileFilledPurple,
  cartBagFilledPurple,
  documentsFilledPurple,
  withdrawalsFilledPurple,
  // gameHistoryFilledPurple,
  transactionsFilledPurple,
  justiceScaleFilledPurple,
};

export const profileFilledLightIcons = {
  topupFilledLight,
  boxesFilledLight,
  profileFilledLight,
  cartBagFilledLight,
  documentsFilledLight,
  withdrawalsFilledLight,
  transactionsFilledLight,
  justiceScaleFilledLight,
};

export const profileOutlinedLightIcons = {
  topupOutlinedLight,
  boxesOutlinedLight,
  profileOutlinedLight,
  cartBagOutlinedLight,
  documentsOutlinedLight,
  withdrawalsOutlinedLight,
  transactionsOutlinedLight,
  justiceScaleOutlinedLight,
};

export const profileFilledDarkIcons = {
  topupFilledDark,
  boxesFilledDark,
  profileFilledDark,
  cartBagFilledDark,
  documentsFilledDark,
  withdrawalsFilledDark,
  gameHistoryFilledDark,
  transactionsFilledDark,
  justiceScaleFilledDark,
};

export const profileOutlinedDarkIcons = {
  topupOutlinedDark,
  boxesOutlinedDark,
  profileOutlinedDark,
  cartBagOutlinedDark,
  documentsOutlinedDark,
  withdrawalsOutlinedDark,
  transactionsOutlinedDark,
  justiceScaleOutlinedDark,
  trashCanFilledDark,
  trashCanFilledLight,
  trashCanOutlinedDark,
  trashCanOutlinedLight,
  trashCanOutlinedPurple,
};

export const card = { deposit, registerTopup, productsBattle };
